module.exports = __webpack_public_path__ + "static/media/safety_risk_assessment.5b3bb2aa.png";